import { putProviders } from '../api/putProviders';

export const setPutProviders = (params) => {
    return async (dispatch, getState) => {
        try {
            await putProviders(params);
            alert('Сохранено')
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}